module.exports = "\n.link {\n  stroke-width: 0.25;\n  stroke: rgb(222,237,250);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/visuals/shared/link-visual/link-visual.component.css
// module id = ./src/app/visuals/shared/link-visual/link-visual.component.css
// module chunks = main